import { styled } from "styled-components";
const CardButtonImpl = styled("div").attrs(({ as }) => ({
  role: as === void 0 ? "button" : void 0,
  tabIndex: 0
}))({
  border: "1px solid transparent",
  borderRadius: "inherit",
  "&:hover": {
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
  },
  "&:focus": {
    boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.05)"
  },
  "&:hover:focus": {
    boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.05), 0px 2px 8px rgba(0, 0, 0, 0.05)"
  },
  "&:active, &:hover:active": {
    boxShadow: "none"
  },
  cursor: "pointer",
  flex: "1 1 0",
  minWidth: 0,
  outline: 0,
  position: "relative",
  transition: "box-shadow 0.3s"
});
export {
  CardButtonImpl
};
